module.exports = __webpack_public_path__ + "static/media/Piercing-mouth-bottom-labret.b656ff9a.png";